import { put } from 'redux-saga/effects';
import { BinderFormState } from 'components/ModalWindows/ManageBinder/binderFormReducer';
import { UploadProjectType } from 'const';
import { uploadToPromoMats } from '../actions';

interface CreateBinderPayload {
  binderForm: BinderFormState;
  uploadProjectType: UploadProjectType;
  translationComplete: boolean;
}

export function* createBinderAndUpload(action: { payload: CreateBinderPayload }): Generator {
  try {
    const { binderForm, uploadProjectType, translationComplete } = action.payload;

    yield put(uploadToPromoMats(uploadProjectType, translationComplete, binderForm));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in createBinderAndUpload saga:', error);
  }
}
